var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('vue-upload-multiple-image',{attrs:{"dragText":"Drag images (multiple)","browseText":"(or) Select","primaryText":"First Photo"},on:{"upload-success":_vm.uploadImageSuccess,"before-remove":_vm.beforeRemove}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }